export default __webpack_public_path__ + "static/media/placeholder_business04-en-web.c56c29c8.png";